import React, { useState } from 'react';
import { updateUserDisplayName } from '../firebase/auth';
import { mapAuthError } from '../utils/userFacingErrors';
import Icon from './Icon';
import './NameOnboarding.css';

function NameOnboarding({ onComplete }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const trimmed = name.trim();
    if (!trimmed) {
      setError('Please enter your first name.');
      return;
    }

    setLoading(true);
    try {
      const user = await updateUserDisplayName(trimmed);
      onComplete(user);
    } catch (err) {
      setError(mapAuthError(err, 'signUp'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="apr-overlay name-onboarding-overlay">
      <div className="apr-dialog name-onboarding-card" role="dialog" aria-modal="true" aria-labelledby="name-onboarding-title">
        <span className="apr-dialog-grabber" aria-hidden="true" />
        <h2 id="name-onboarding-title" className="apr-dialog-title">What should Rob call you?</h2>
        <p className="apr-dialog-body name-onboarding-copy">
          Share your first name so conversations feel more personal.
        </p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="onboarding-name" className="form-label">First name</label>
          <input
            id="onboarding-name"
            type="text"
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your first name"
            autoComplete="given-name"
            autoFocus
            required
            maxLength={40}
          />
          {error && (
            <div className="apr-error name-onboarding-error" role="alert">
              <Icon name="triangle-alert" size={16} />
              <span>{error}</span>
            </div>
          )}
          <button type="submit" className="apr-btn apr-btn--block name-onboarding-submit" disabled={loading}>
            {loading ? 'Saving…' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default NameOnboarding;
